import { Fragment, useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { useSelector } from "react-redux";
import SocketProvider from "./socket/SocketProvider";
import SnackContainer from "./components/SnackContainer";
import AppRoutes from "./routes";

function App() {
  return (
    <Fragment>
      <AppRoutes />
      <Toaster
      position="top-center"
      reverseOrder={false}
      />
      <SocketProvider />
      <SnackContainer />
    </Fragment>
  );
}

export default App;
